import { PlusIcon } from "@heroicons/react/24/outline";
import { useRef } from "react";
import { Button } from "@/core/components/ui/button";
import { EDITOR_LIMITS } from "@/payroll/editor/constants";
import type { PayrollEditorQueries } from "@/payroll/editor/query";
import type { EditorUpload } from "./use-editor-upload";
/** The composer's attach control — paired with the chips below. */
export const AttachButton = ({
  documents,
  upload,
  disabled,
}: {
  documents: PayrollEditorQueries["documents"];
  upload: EditorUpload;
  disabled: boolean;
}) => {
  const input = useRef<HTMLInputElement>(null);
  const files = documents.data ?? [];
  const full = files.length >= EDITOR_LIMITS.files && !upload.hasReceipt;
  return (
    <>
      <Button
        type="button"
        size="icon"
        variant="ghost"
        // 32px, off the 4px scale on purpose: the tray should read as quiet
        // marks under the text, and the send circle should be the only weight
        // in the row.
        className="h-7 w-7 min-w-7 rounded-full text-tertiary-text hover:bg-gray-10 hover:text-primary-text"
        title={
          full
            ? `Remove a file first. ${EDITOR_LIMITS.files} is the limit`
            : "Attach a file (20 MB max)"
        }
        aria-label="Attach a file"
        disabled={
          disabled ||
          full ||
          upload.isUploading ||
          !!upload.pending ||
          documents.isPending ||
          documents.isError
        }
        onClick={() => input.current?.click()}
      >
        <PlusIcon className="h-4 w-4" />
      </Button>
      <input
        ref={input}
        type="file"
        className="hidden"
        aria-label="Upload payroll file"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) upload.selectFile(file);
          event.target.value = "";
        }}
      />
    </>
  );
};
